import React, { useContext, useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import PropTypes from 'prop-types';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import './VSvgToolbar.css';
import _ from 'lodash';

const VSvgToolbar = props => {
  const { selectedEntity } = props;
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const svgState = useSelector(state => state.design.svgsState[selectedEntity]);
  const colorPickerColor = useSelector(state => state.design.colorPickerColor);

  const [click, setClick] = useState({});

  useEffect(() => {
    console.log('svg-toolbar');
  });

  useEffect(() => {
    if (click.index && _.get(svgState[click.index], click.type) !== colorPickerColor) {
      if (click.type === 'fill')
        dispatch(designActions.changeColorPickerColor(svgState[click.index].fill));
      if (click.type === 'stroke')
        dispatch(designActions.changeColorPickerColor(svgState[click.index].stroke));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [svgState]);

  useEffect(() => {
    let colors = {};
    if (click.index > -1 && _.get(svgState[click.index], click.type) !== colorPickerColor) {
      if (svgState && svgState[click.index]) {
        colors.fill = click.type === 'fill' ? colorPickerColor : _.get(svgState[click.index], 'fill');
        colors.stroke =
          click.type === 'stroke' ? colorPickerColor : _.get(svgState[click.index], 'stroke');

        dispatch(
          designActions.changeSvgColor(activePageRef.current, selectedEntity, {
            index: click.index,
            fill: colors.fill,
            stroke: colors.stroke,
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorPickerColor]);

  const onMouseDown = (index, color, type) => {
    dispatch(designActions.changeColorPickerColor(color));
    dispatch(designActions.setSidePanel('colorPicker'));
    if (type === 'fill')
      setClick({
        index: index,
        type: type,
        selected: 'selected',
        fill: color,
        entity: selectedEntity,
      });
    if (type === 'stroke')
      setClick({
        index: index,
        type: type,
        selected: 'selected',
        stroke: color,
        entity: selectedEntity,
      });
  };

  return (
    <div className="toolbar">
      {svgState && (
        <div className="colorPalette">
          {svgState.slice(0, 7).map((color, index) => {
            let fillBtn, strokeBtn;
            if (color.fill && color.fill !== 'none') {
              fillBtn = (
                <span
                  key={index}
                  className={
                    `color ${index} ` +
                    (click.index === index && click.type === 'fill' ? 'selected' : '')
                  } //{`color ${selected}`}
                  style={{ backgroundColor: `${color.fill}` }}
                  onMouseDown={() => onMouseDown(index, color.fill, 'fill')}
                ></span>
              );
            }
            if (color.stroke && color.stroke !== 'none') {
              strokeBtn = (
                <span
                  key={index}
                  className={
                    `color ${index} ` +
                    (click.index === index && click.type === 'stroke' ? 'selected' : '')
                  } //{`color ${selected}`}
                  style={{ backgroundColor: `${color.stroke}` }}
                  onMouseDown={() => onMouseDown(index, color.stroke, 'stroke')}
                ></span>
              );
            }
            return (
              <>
                {fillBtn}
                {strokeBtn}
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};

VSvgToolbar.propTypes = {
  selectedEntity: PropTypes.number,
};

export default VSvgToolbar;
